import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuStylingOption} from '@Components/contextual-menu/components/contextual-menu-styling-option';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import type {IconStates} from '@Components/contextual-menu/components/styling-options';
import {TextVerticalAlignType} from '@PosterWhiteboard/classes/text-styles.class';
import type {TranscriptVerticalAlignOptionProps} from '@Components/poster-editor/components/poster-editing-side-panel/components/transcript-vertical-align-option/transcript-vertical-align-option.types';
import {IconSize} from '@Components/icon-v2/icon.types';
import {useGetKeyFromTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromTranscriptItem';

export function TranscriptVerticalAlignOption({showLargeIcons = false}: TranscriptVerticalAlignOptionProps): ReactElement<any> {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptVerticalAlignOption');
  }

  const verticalAlign = useGetKeyFromTranscriptItem('verticalAlign');
  if (!verticalAlign) {
    throw new Error('Transcript item does not have verticalAlign attribute');
  }

  const updateAppliedVerticalAlignment = async (verticalAlignment: TextVerticalAlignType): Promise<void> => {
    await activeItem.updateFromObject({
      verticalAlign: verticalAlignment,
    });
  };

  const getVerticalAlignmentOptionsData = (): IconStates[] => {
    return [
      {
        id: TextVerticalAlignType.TOP,
        icon: 'icon-v-align-up',
        isSelected: verticalAlign === TextVerticalAlignType.TOP,
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
      },
      {
        id: TextVerticalAlignType.CENTER,
        icon: 'icon-v-align-center',
        isSelected: verticalAlign === TextVerticalAlignType.CENTER,
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
      },
      {
        id: TextVerticalAlignType.BOTTOM,
        icon: 'icon-v-align-bottom',
        isSelected: verticalAlign === TextVerticalAlignType.BOTTOM,
        iconSize: showLargeIcons ? IconSize.SIZE_ICON_24 : IconSize.SIZE_ICON_16,
      },
    ];
  };

  return (
    <ContextualMenuStylingOption
      id="subtitle-text-letter-case-option"
      label={window.i18next.t('pmwjs_vertical_align')}
      data={getVerticalAlignmentOptionsData()}
      onClick={updateAppliedVerticalAlignment}
    />
  );
}
